"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Expo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Expo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.667a3.127 3.127 0 0 0 1.233-.423l.524-.315A.5.5 0 0 0 16 3.5v-3a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .243.429l.524.315c.378.226.798.37 1.233.422V7.5h-.5A.5.5 0 0 0 1 8v7.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H14V4.667Zm-5.733-.423L8 4.084l-.267.16a3.126 3.126 0 0 1-3.216 0l-.267-.16-.267.16A3.126 3.126 0 0 1 3 4.626V7.5h10V4.626c-.345-.07-.678-.2-.983-.382l-.267-.16-.267.16a3.126 3.126 0 0 1-3.216 0ZM2 8.5V15h12V8.5H2Zm5.485-5.274-.266.16a2.128 2.128 0 0 1-2.187 0l-.267-.16a1 1 0 0 0-1.03 0l-.267.16a2.127 2.127 0 0 1-2.186 0L1 3.217V1h14v2.217l-.281.17a2.129 2.129 0 0 1-2.187 0l-.267-.161a1 1 0 0 0-1.03 0l-.266.16a2.129 2.129 0 0 1-2.187 0l-.267-.16a1 1 0 0 0-1.03 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Expo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Expo;
exports["default"] = _default;